module.exports = __webpack_public_path__ + "static/media/bizbook-button-img.ac9be5a6.png";